import { Grid, Typography } from "@mui/material";

import { Paper } from "../../../components";
import { colors } from "../../css components/Style";

export default function CampaignStatus({ formikProps }) {
  return (
    <Paper>
      <Grid item xs={12}>
        <Typography
          style={{
            fontSize: "15px",
            color: colorPicker(formikProps.values.requestStatus),
          }}
        >
          Approval Status -{" "}
          {formikProps.values.requestStatus.replace(/_/g, " ").toUpperCase()}
        </Typography>
        <Typography
          style={{
            fontSize: "15px",
            color: colorPicker(formikProps.values.campaign_status),
          }}
        >
          Campaign Status -{" "}
          {formikProps.values.campaign_status.replace(/_/g, " ").toUpperCase()}
        </Typography>
      </Grid>
    </Paper>
  );

  function colorPicker(status) {
    let color;
    if (status === "REQUESTED" || status === "CREATED") {
      color = colors.yellow;
    }

    if (
      status === "OFFER_ACCEPTED" ||
      status === "ACTIVE" ||
      status === "ACCEPTED" ||
      status === "PARTIAL_ACCEPTED"
    ) {
      color = colors.green;
    }

    if (status === "INITIATED") {
      color = colors.initiated;
    }

    if (
      status === "REJECTED" ||
      status === "FAILED" ||
      status === "PARTIAL_REJECTED" ||
      status === "OFFER_REJECTED"
    ) {
      color = colors.error;
    }

    if (status === "Expired") {
      color = "#bdbdbd";
    }

    if (status === "READY") {
      color = colors.success;
    }

    return color;
  }
}
